export default [
    {
        path: '/',
        name: '',
        meta: {
            crumb: ''
        },
        component: (resolve)=>require(['@/pages/index.vue'], resolve),
        children: [
            {
                path: 'batt-list',
                name: '',
                meta: {
                    crumb: ''
                },
                component: (resolve)=>require(['@/pages/batt-list/index.vue'], resolve),
                children: [
                    {
                        path: 'real-time',
                        name: 'PagesControl',
                        meta: {
                            crumb: '实时数据'
                        },
                        component: (resolve)=>require(['@/pages/batt-list/real-time-page.vue'], resolve)
                    },
                    {
                        path: 'history',
                        name: 'PagesHistory',
                        meta: {
                            crumb: '历史数据'
                        },
                        component: (resolve)=>require(['@/pages/batt-list/history-page.vue'], resolve)
                    },
                ]
            },
            {
                path: 'user',
                name: 'PagesUser',
                meta: {
                    crumb: ''
                },
                component: (resolve)=>require(['@/pages/user/index.vue'], resolve),
                children: [
                    {
                        path: 'info',
                        name: 'UserInfo',
                        meta: {
                            crumb: '用户信息管理'
                        },
                        component: (resolve)=>require(['@/pages/user/info.vue'], resolve)
                    },
                    {
                        path: 'power',
                        name: 'UserPower',
                        meta: {
                            crumb: '用户权限管理'
                        },
                        component: (resolve)=>require(['@/pages/user/power.vue'], resolve)
                    },
                    {
                        path: 'baoji',
                        name: 'UserBaoji',
                        meta: {
                            crumb: '包机组管理'
                        },
                        component: (resolve)=>require(['@/pages/user/baoji.vue'], resolve)
                    },
                ]
            }
        ],
    },
    {
        path: '/login',
        name: '',
        meta: {
            crumb: ''
        },
        component: (resolve)=>require(['@/pages/login.vue'], resolve),
    },
]